import { CUSTOMER_STORIES_PLATFORMS } from "@/app/_utilities/customerStoriesPlatforms";

/** Tab order shown at the top of the grid. */
export const PLATFORM_TAB_ORDER = CUSTOMER_STORIES_PLATFORMS;
